module.exports = __webpack_public_path__ + "img/globe-nav-chevron-up-darkgrey.540cb741.svg";